import { cn } from "@babybjorn/ui";
import type { FC, PropsWithChildren } from "react";
import Button from "../../../components/general/Button";
import * as s from "./Reviews.module.scss";

type ReviewsProps = PropsWithChildren<{
	label: string;
	hideButtons: boolean;
	onLeftClick: () => void;
	onRightClick: () => void;
	prevLabel: string;
	nextLabel: string;
}>;

const Reviews: FC<ReviewsProps> = ({
	label,
	hideButtons,
	onLeftClick,
	onRightClick,
	prevLabel,
	nextLabel,
	children,
}) => (
	<section className={s.reviews}>
		<label className={s.label}>{label}</label>
		<div className={s.listContainer}>
			<Button
				buttonType="icon"
				variant="noBg"
				icon="arrow-left"
				onClick={onLeftClick}
				className={cn({ [s.hideButtons]: hideButtons })}
				aria-label={prevLabel}
			/>
			<div className={s.list}>{children}</div>
			<Button
				buttonType="icon"
				variant="noBg"
				icon="arrow-right"
				onClick={onRightClick}
				className={cn({ [s.hideButtons]: hideButtons })}
				aria-label={nextLabel}
			/>
		</div>
	</section>
);

export default Reviews;
